export const descriptionTop = '32vh';
